import React, { Component } from 'react';
import { Card, Select, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import CalendarCell from './components/CalendarCell';

const { Option } = Select;

class CalendarModule extends Component {
    state = {
        loading: false,
        calendarData: [],
        selectableRange: { min: '', max: '' },
    };

    componentDidMount() {
        if (this.props.selectedMonth) {
            this.loadCalendarData(this.props.selectedMonth);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.selectedMonth !== this.props.selectedMonth) {
            this.loadCalendarData(this.props.selectedMonth);
        }
        if (prevProps.refreshKey !== this.props.refreshKey) {
            this.loadCalendarData(this.props.selectedMonth);
        }
    }

    loadCalendarData = (yearMonth) => {
        this.setState({ loading: true });
        const { userId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.monthlyPlan.queryCalendarData,
            data: { curUserId: userId, yearMonth },
            dataType: 'json',
            doneResult: (res) => {
                if (res.success) {
                    this.setState({
                        calendarData: res.data || [],
                        selectableRange: res.selectableRange || { min: '', max: '' },
                    });
                }
                this.setState({ loading: false });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    };

    handleMonthChange = (value) => {
        this.props.onMonthChange(value);
    };

    handleDateClick = (date) => {
        this.props.onDateSelect(date);
    };

    generateMonthOptions = () => {
        const { selectableRange } = this.state;
        const { min, max } = selectableRange;
        if (!min || !max) return [];

        const options = [];
        const [minY, minM] = min.split('-').map(Number);
        const [maxY, maxM] = max.split('-').map(Number);
        let currentY = minY;
        let currentM = minM;

        while (currentY < maxY || (currentY === maxY && currentM <= maxM)) {
            const value = `${String(currentY)}-${String(currentM).padStart(2, '0')}`;
            const label = `${currentY}年${currentM}月`;
            options.push(<Option key={value} value={value}>{label}</Option>);
            currentM++;
            if (currentM > 12) {
                currentM = 1;
                currentY++;
            }
        }
        return options;
    };

    renderCalendarGrid = () => {
        const { calendarData } = this.state;
        const { selectedDate } = this.props;

        if (!calendarData || calendarData.length === 0) {
            return null;
        }

        const weeks = ['一', '二', '三', '四', '五', '六', '日'];
        const rows = [];

        // 表头
        rows.push(
            <div className="calendar-header" key="header">
                {weeks.map((day) => (
                    <div className="calendar-weekday" key={day}>{day}</div>
                ))}
            </div>
        );

        // 日历单元格
        const cells = calendarData.map((day, index) => (
            <CalendarCell
                key={index}
                date={day.date}
                dayNum={day.dayNum}
                isRest={day.isRest}
                planVisitCount={day.planVisitCount || 0}
                planStartCount={day.planStartCount || 0}
                hasMemo={day.hasMemo}
                isCurrentMonth={day.isCurrentMonth}
                isToday={day.isToday}
                isSelected={day.date === selectedDate}
                onClick={() => this.handleDateClick(day.date)}
            />
        ));

        // 分成行
        const rowCount = Math.ceil(cells.length / 7);
        for (let i = 0; i < rowCount; i++) {
            rows.push(
                <div className="calendar-row" key={`row-${i}`}>
                    {cells.slice(i * 7, (i + 1) * 7)}
                </div>
            );
        }

        return rows;
    };

    render() {
        const { loading, calendarData } = this.state;
        const { selectedMonth } = this.props;

        return (
            <Card
                className="calendar-module"
                title="日历"
                extra={
                    <Select
                        value={selectedMonth}
                        onChange={this.handleMonthChange}
                        style={{ width: 150 }}
                    >
                        {this.generateMonthOptions()}
                    </Select>
                }
            >
                <Spin spinning={loading}>
                    <div className="calendar-grid">
                        {this.renderCalendarGrid()}
                    </div>
                </Spin>
            </Card>
        );
    }
}

export default CalendarModule;



// WEBPACK FOOTER //
// ./src/components/homePage/monthlyPlan/CalendarModule.js